// With the scopes shown, each scope's name heads its first service: [{ head?, item }] in order.
export const withHeads = (doc, items, rowOf = (x) => x) => {
  let last;
  return items.map((item) => {
    const s = rowOf(item);
    if (!doc.show_scopes || s.scope_key === last) return { item };
    last = s.scope_key;
    return { head: s.scope || '', item };
  });
};
